<template>
  <div class="card-border">
    <AccordionInfoDisplay
      :heading="heading"
      :isExpanded="isExpanded"
      :leftIcon="leftIcon"
      :subText="subText"
      :tabIndex="tabIndex"
      @onClicked="$emit('onClicked')"
    />
    <div v-show="isExpanded" class="content"><slot name="content" /></div>
  </div>
</template>
<script lang="ts" setup>
import AccordionInfoDisplay from '@/components/features/info-display/AccordionInfoDisplay.vue'

defineEmits(['onClicked'])
withDefaults(
  defineProps<{
    heading: string
    isExpanded?: boolean
    leftIcon?: boolean
    subText?: string
    tabIndex?: number
  }>(),
  {
    heading: '',
    isExpanded: false,
    leftIcon: false,
    subText: '',
    tabIndex: 0
  }
)
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
.card-border {
  border-radius: 4px;
  border: 1px solid variables.$color-greyscale-line-grey;
  background: variables.$color-pure-white;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);
}

.content {
  padding: 0 16px 16px;
}
</style>
